import styled, { css } from "styled-components";
import { useDesignTokens, parseSizeToken } from "@boi/react-design-tokens";

type ContentProps = {
  $withIcon: boolean;
};

export const Content = styled.div<ContentProps>`
  ${({ $withIcon }) => {
    const { tokens } = useDesignTokens();
    const { iconButtonMenu } = tokens;

    return [
      css`
        display: grid;
        gap: ${iconButtonMenu.menu.item.content.gap};
        padding-top: ${iconButtonMenu.menu.item.content.padding.top};
        padding-left: ${iconButtonMenu.menu.item.content.padding.left};
        padding-right: ${iconButtonMenu.menu.item.content.padding.right};
        padding-bottom: ${iconButtonMenu.menu.item.content.padding.bottom};
        overflow-wrap: anywhere;
      `,
      $withIcon &&
        css`
          grid-template-columns: auto 1fr;
        `,
    ];
  }}
`;

export const ContentIconWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { iconButtonMenu } = tokens;

    return [
      css`
        display: grid;
        place-items: center;
        height: ${parseSizeToken(
          iconButtonMenu.menu.item.content.iconWrapper.height
        )};

        svg {
          display: block;
          width: ${iconButtonMenu.menu.item.content.icon.width};
          height: ${iconButtonMenu.menu.item.content.icon.height};
        }
      `,
    ];
  }}
`;
